export enum Stand {
  dev = 'dev',
  prod = 'prod'
}
